import classNames from 'classnames';
import React from 'react';

import css from './IconTextile.module.css';

const IconTextile = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="#011602"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      >
        <path d="m9.754 15.88-.046.03a6.5 6.5 0 1 1-.004-11.823l.05.032" />
        <path d="M1.77 13.861a6.5 6.5 0 0 1 8.299-8.025l.119.054" />
        <path d="M2.54 14.73a6.5 6.5 0 0 1 7.71-7.109l.159.038M14.698 16.08a6.5 6.5 0 1 0 .017-12.168l-.03.013" />
        <path d="M22.231 6.144a6.5 6.5 0 0 1-7.082 8.301l-.022-.008" />
        <path d="M15.423 12.486a6.5 6.5 0 0 0 6.037-7.214" />
        <path d="M14.5 3.5s1 1.773 1 6.5-1 6.5-1 6.5h-5s1-1.773 1-6.5-1-6.5-1-6.5h5z" />
        <path d="M3.5 10.5s1.115 4 6.615 4M5.5 8.524s-.536 2.977 4.964 2.976M15.116 5.5s4.384.19 4.384 5.19M15.464 8.5s2.036.024 2.036 3.502M14.5 16.5l3.675.735c.77.154 1.325.83 1.325 1.616v0c0 .91-.738 1.649-1.649 1.649H12.5" />
      </g>
    </svg>
  );
};

export default IconTextile;
